var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.adfb2759c1f73dcfc0efb6a2618f4f2b.svg#move';
                    var viewUrl = 'svg/global.adfb2759c1f73dcfc0efb6a2618f4f2b.svg#view-move';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };